/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Vehicle } from '@shared/models';

@Component({
    selector: 'app-vehicle-deactivation-confirmation',
    templateUrl: './vehicle-deactivation-confirmation.component.html',
    styleUrls: ['./vehicle-deactivation-confirmation.component.scss'],
    standalone: false
})
export class VehicleDeactivationConfirmationComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { vehicle: Vehicle }
  ) {
  }
}
